<template>
  <hr class="w-full h-px bg-neutral-200" data-testid="divider" />
</template>
